import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import codes from '../utils/constants/codes';

const REQUEST_COMMUNICATOR_MESSAGE = 'requestCommunicatorMessage';
const REQUEST_COMMUNICATOR_HISTORY = 'requestCommunicatorHistory';
const REQUEST_CREATE_COMMUNICATOR_MESSAGE = 'requestCreateCommunicatorMessage';

export function requestCommunicatorMessageAftermakingMessage(sources) {
    const action$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.CREATE_COMMUNICATOR_MESSAGE_SUCCESS,
    ).map(action => {
        return actions.fetchCommunicatorHistory({
            claimApplicationId: action.payload.request.send.claimApplicationId,
        });
    });

    return {
        ACTION: action$,
    };
}

export function requestCommunicatorMessage(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_COMMUNICATOR_MESSAGE;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                `api/message/claimApplication/${action.payload.claimApplicationId}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_COMMUNICATOR_MESSAGE,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_COMMUNICATOR_MESSAGE)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchCommunicatorMessageSuccess(response)
                : actions.fetchCommunicatorMessageFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestCreateCommunicatorMessage(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.CREATE_COMMUNICATOR_MESSAGE,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            // url: GENERAL_FUNCTIONS.getBaseURL() + 'api/message',
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/Communication/claimant',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CREATE_COMMUNICATOR_MESSAGE,
            method: 'POST',
            send: action.payload,
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CREATE_COMMUNICATOR_MESSAGE)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.createCommunicatorMessageSuccess(response)
                : actions.createCommunicatorMessageFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestCommunicatorHistory(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_COMMUNICATOR_HISTORY;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                `api/Communicator/${action.payload.claimApplicationId}/history${action.payload?.filters ? GENERAL_FUNCTIONS.createUrlQueryParameters(action.payload.filters) : GENERAL_FUNCTIONS.createUrlQueryParameters(codes.defaultPayloadPagination)}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_COMMUNICATOR_HISTORY,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_COMMUNICATOR_HISTORY)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchCommunicatorHistorySuccess(response)
                : actions.fetchCommunicatorHistoryFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
